import React, { useState } from "react";
import { Link } from "react-router-dom";

function Navbar() {
  const [showMenu, setShowMenu] = useState(false);
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  return (
    <div className="w-11/12 md:w-10/12 h-[7vh] absolute top-0 z-40 flex items-center pb mt-2 border-b border-white/40 justify-between">
      <div className="md:hidden block">
        <i
          onClick={toggleMenu}
          className="fa-solid fa-bars cursor-pointer !text-white/60 hover:!text-white"
        ></i>
      </div>
      <p className="text-xl font-extrabold">audiophile.</p>
      <ul className="hidden md:inline-flex gap-4 text-[10px] text-white/60 font-semibold tracking-wide">
        <Link to="/" className="cursor-pointer uppercase hover:text-white">
          HOME
        </Link>
        <Link
          to="category/Headphones"
          className="cursor-pointer uppercase hover:text-white"
        >
          HEADPHONES
        </Link>
        <Link
          to="category/Speakers"
          className="cursor-pointer uppercase hover:text-white"
        >
          SPEAKERS
        </Link>
        <Link
          to="category/Earphones"
          className="cursor-pointer uppercase hover:text-white"
        >
          EARPHONES
        </Link>
      </ul>
      <Link to="cart">
        <i className="fa-solid fa-cart-shopping cursor-pointer !text-white/60 hover:!text-white"></i>
      </Link>
      {showMenu && (
        <div className="bg-white/70 backdrop-blur-md border border-black/30 p-2 absolute w-full text-black flex flex-col text-[12px] gap-1 font-semibold -bottom-[15vh]">
          <Link
            to="/"
            onClick={toggleMenu}
            className="cursor-pointer uppercase w-max hover:bg-black hover:text-white hover:pl-0.5 hover:py-0.5 hover:pr-4"
          >
            HOME
          </Link>
          <Link
            to="category/Headphones"
            onClick={toggleMenu}
            className="cursor-pointer uppercase w-max hover:bg-black hover:text-white hover:pl-0.5 hover:py-0.5 hover:pr-4"
          >
            HEADPHONES
          </Link>
          <Link
            to="category/Speakers"
            onClick={toggleMenu}
            className="cursor-pointer uppercase w-max hover:bg-black hover:text-white hover:pl-0.5 hover:py-0.5 hover:pr-4"
          >
            SPEAKERS
          </Link>
          <Link
            to="category/Earphones"
            onClick={toggleMenu}
            className="cursor-pointer uppercase w-max hover:bg-black hover:text-white hover:pl-0.5 hover:py-0.5 hover:pr-4"
          >
            EARPHONES
          </Link>
        </div>
      )}
    </div>
  );
}

export default Navbar;
